import { memo } from 'react';
import Image from 'next/legacy/image';
import { Grid } from 'ht-styleguide';
import newsItems from './inthenews.data';
import styles from './inthenews.module.scss';

/* Types */
type BaseBlockContent = {
  title: string;
  content: string;
  image: string;
  link: string;
  href: string;
};

const InTheNews = () => {
  const displayNews = () =>
    newsItems.items.map((item: BaseBlockContent) => (
      <Grid.Column sm={4} md={4} lg={4} classes={styles.item} key={item.title}>
        <Image quality={30} layout="intrinsic" height={24} width={124} className={styles.image} alt={item.title} src={item.image} />
        <h5 className="h5 paddingTop-tiny1">{item.title}</h5>
        <div className="p2 n700 paddingTop-tiny1 paddingBottom-tiny1">{item.content}</div>
        <a href={item.href} className="p2" rel="noopener noreferrer" target="_blank">
          {item.link}
        </a>
      </Grid.Column>
    ));

  return (
    <div className={styles.container}>
      <Grid.FullWidth>
        <Grid.Row>
          <Grid.Column>
            <h3 className="h3 text-align-center">{newsItems.title}</h3>
          </Grid.Column>
        </Grid.Row>

        <Grid.Row classes={styles.list}>{displayNews()}</Grid.Row>
      </Grid.FullWidth>
    </div>
  );
};

export default memo(InTheNews);
